import { FormBasicsDto } from "@green0meter/api-client";
import React, { Dispatch, FC, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

import { useGetAvailableForms } from "@api";
import { MenuItem, Select } from "@components/base";
import { useUserStore } from "@store/user";

interface FormSelect {
  form: FormBasicsDto | undefined;
  setForm: Dispatch<SetStateAction<FormBasicsDto | undefined>>;
}

const FormSelect: FC<FormSelect> = ({ form, setForm }) => {
  const { t } = useTranslation();
  const { user } = useUserStore();
  const { availableForms } = useGetAvailableForms(user, []);

  return (
    <Select
      variant="filled"
      // @ts-expect-error - TODO verify if this is a wrong type or not. Remove if not necessary
      placeholder={t("formSelect.placeholder")}
      value={form?.id}
      size="small"
      displayEmpty
    >
      <MenuItem value={undefined} onClick={() => setForm(undefined)}>
        {t("formSelect.allForms")}
      </MenuItem>
      {availableForms?.map((form) => (
        <MenuItem key={form.id} value={form.id} onClick={() => setForm(form)}>
          {form.name}
        </MenuItem>
      ))}
    </Select>
  );
};

export default FormSelect;
